(function () {
  var rafId = null;

  function setDisplayIfChanged(element, nextDisplay) {
    if (!element || element.style.display === nextDisplay) {
      return;
    }

    element.style.display = nextDisplay;
  }

  function updateFabrikatorShipment(variantId) {
    if (!variantId) {
      return;
    }

    var variantsLists = document.querySelectorAll('.fabrikator__variants-metafields');

    if (!variantsLists.length) {
      return;
    }

    variantsLists.forEach(function (variantsList) {
      var container = variantsList.closest('.shopify-app-block, .product-info__block-item') || variantsList.parentElement;

      if (!container) {
        return;
      }

      var shipmentText = container.querySelector('.fabrikator__shipment-text');

      if (!shipmentText) {
        return;
      }

      var variantItem = variantsList.querySelector('li[data-variant-id="' + variantId + '"]');

      if (!variantItem) {
        setDisplayIfChanged(shipmentText, 'none');
        return;
      }

      var backorderDate = (variantItem.textContent || '').trim();
      var dateSpan = shipmentText.querySelector('span');

      if (dateSpan && dateSpan.textContent !== backorderDate) {
        dateSpan.textContent = backorderDate;
      }

      setDisplayIfChanged(shipmentText, backorderDate ? 'block' : 'none');
    });
  }

  function scheduleUpdate(variantId) {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }

    rafId = requestAnimationFrame(function () {
      updateFabrikatorShipment(variantId);
    });
  }

  function getCurrentVariantIdFromForm() {
    var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (!variantInput || !variantInput.value) {
      return null;
    }

    return String(variantInput.value);
  }

  document.addEventListener('variant:change', function (evt) {
    var variantId = evt && evt.detail && evt.detail.variant && evt.detail.variant.id;

    if (!variantId) {
      return;
    }

    scheduleUpdate(String(variantId));
  });

  document.addEventListener('DOMContentLoaded', function () {
    var currentVariantId = getCurrentVariantIdFromForm();

    if (!currentVariantId) {
      return;
    }

    scheduleUpdate(currentVariantId);
  });
})();
